export default __webpack_public_path__ + "static/media/shinobi-white.e39a2a4b.svg";